// @flow

import type { PaginationHeaders } from '@globalTypes';
import {
  FACILITY_SEARCH_REQUEST,
  FACILITY_SEARCH_REQUESTED,
  FACILITY_SEARCH_REQUESTED_ERROR,
  FACILITY_SEARCH_RESET,
  FACILITY_SEARCHBAR_REQUEST,
  FACILIITY_SEARCHBAR_REQUESTED
} from './constants';

import type {
  Action, Items, Company, CompanyPlace, Photo
} from '../types';

export const requestFacilityList = (
  requestPayload: {
    pageNumber?: number,
    location?: string,
    address_city?: string,
    departments?: string,
    dontScroll?: boolean,
    custom_items_per_page?: number,
    facility_ids?: Array<string>
  } = {}
): Action => ({
  type: FACILITY_SEARCH_REQUEST,
  ...requestPayload
});

export const requestFacilityListSearchBar = (
  requestPayload: {
    pageNumber?: number,
    location?: string,
    department?: string,
    address_city?: string,
    facilityName?: string
  } = {}
): Action => ({
  type: FACILITY_SEARCHBAR_REQUEST,
  ...requestPayload
});

export const updateFacilityListSearchABar = (
  data: Items,
  included: Array<Company | CompanyPlace | Photo>,
  headers: PaginationHeaders
): Action => ({
  type: FACILIITY_SEARCHBAR_REQUESTED,
  data,
  headers,
  included
});

export const updateFacilityList = (
  data: Items,
  included: Array<Company | CompanyPlace | Photo>,
  headers: PaginationHeaders
): Action => ({
  type: FACILITY_SEARCH_REQUESTED,
  data,
  headers,
  included
});

export const errorFacilityList = (error: Error): Action => ({
  type: FACILITY_SEARCH_REQUESTED_ERROR,
  error
});

export const resetFacilityList = (): Action => ({
  type: FACILITY_SEARCH_RESET
});
